import { Types, theme } from '@fiverr-private/theme';

export const RING_PADDING = '0.5';
export const getRingStyles = ({ shape, borderRadius }): Types.Box => ({
    borderStyle: 'solid',
    borderColor: 'business_1100',
    borderWidth: 'md',
    padding: RING_PADDING,
    ...(shape === 'square' && {
        style: {
            borderRadius: `calc(${theme.borderRadiuses[borderRadius]} + ${theme.spacing[RING_PADDING]})`,
        },
    }),
    ...(shape === 'circle' && {
        borderRadius,
    }),
});
